// en strings. Every key must exist in all four tables (npm run check:i18n).
export default {
  "nav.overview": "Overview",
  "nav.domains": "Domains",
  "nav.hosting": "Hosting",
  "nav.email": "Email",
  "nav.backups": "Backups",
  "nav.billing": "Billing",
  "nav.account": "Account",
  "dash.subtitle": "Here's how your services are doing at a glance.",
  "status.allgood": "All systems good",
  "status.attention": "Needs attention",
  "qa.title": "Quick actions",
  "qa.domain": "Add a domain",
  "qa.domain.d": "Register or transfer",
  "qa.mailbox": "Create mailbox",
  "qa.mailbox.d": "New email address",
  "qa.dns": "DNS record",
  "qa.dns.d": "Point or change",
  "qa.restore": "Restore backup",
  "qa.restore.d": "Roll back to a moment",
  "svc.title": "My websites",
  "svc.viewall": "View all",
  "svc.package": "Plan",
  "svc.mailboxes": "Mailboxes",
  "svc.backup": "Last backup",
  "svc.manage": "Manage",
  "svc.expires": "Next invoice",
  "use.title": "Usage",
  "use.disk": "Storage",
  "use.traffic": "Bandwidth",
  "use.mail": "Mail storage",
  "use.of": "of",
  "act.title": "Recent activity",
  "act.viewall": "View all",
  "next.invoice.title": "You have an open invoice",
  "next.invoices.title": "You have open invoices",
  "next.invoice.body": "Total outstanding: {amount}.",
  "next.overdue.body": "Total outstanding: {amount}. An invoice is past its due date.",
  "next.invoice.cta": "View invoices",
  "status.loading": "Checking status…",
  "status.attention.n": "{n} services need attention",
  "status.attention.1": "1 service needs attention",
  "err.network": "Can't reach the server. Check your internet connection and try again.",
  "err.401": "Your session has expired. Please sign in again.",
  "err.login.401": "Incorrect email address or password.",
  "err.login.mfa": "Invalid or expired 2FA code.",
  "err.403": "You don't have access to this.",
  "err.404": "Not found. It may have been removed or may not belong to your account.",
  "err.409": "This already exists or conflicts with an existing setting.",
  "err.code.quota_exceeded": "Not enough space: {quota_mb} MB does not fit, {left_mb} MB is left on {domain}.",
  "err.422": "Some fields are not filled in correctly.",
  "err.429": "Too many attempts. Wait a minute and try again.",
  "err.5xx": "Something went wrong on our side. Please try again later.",
  "err.generic": "Something went wrong. Please try again.",
  "common.everything_ok": "All systems good",
  "dom.title": "Domains",
  "dom.sub": "Manage all your domain names, DNS and forwarding in one place.",
  "dom.add": "Add domain",
  "dom.search": "Search domains…",
  "dom.filter.all": "All",
  "dom.filter.active": "Active",
  "dom.filter.expiring": "Expiring soon",
  "dom.filter.transfer": "Transferring",
  "dom.col.domain": "Domain",
  "dom.col.linked": "Linked to",
  "dom.col.expires": "Expires",
  "dom.col.autorenew": "Auto-renew",
  "dom.col.status": "Status",
  "dom.linked.hosting": "Hosting",
  "dom.linked.forward": "Forwarding",
  "dom.linked.parked": "Parked",
  "dom.status.active": "Active",
  "dom.status.expiring": "Expires in {n} days",
  "dom.status.transfer": "Transfer",
  "dom.add.title": "Which domain do you want?",
  "dom.add.placeholder": "e.g. mycompany",
  "dom.add.btn": "Check availability",
  "dom.add.transfer": "Transfer an existing domain",
  "dd.back": "All domains",
  "dd.tab.overview": "Overview",
  "dd.tab.dns": "DNS",
  "dd.tab.email": "Email routing",
  "dd.tab.forward": "Forwarding",
  "dd.tab.settings": "Settings",
  "dd.owner": "Owner",
  "dd.registered": "Registered",
  "dd.expires": "Expires on",
  "dd.renew": "Renew now",
  "dd.autorenew": "Auto-renew",
  "dd.autorenew.short": "Auto-renew",
  "common.yes": "Yes",
  "common.no": "No",
  "ar.off.title": "Turn off auto-renew?",
  "ar.off.body": "Are you sure you don't want to renew this domain? The domain will be cancelled and become unreachable after the expiry date.",
  "ar.off.meta": "Expires on",
  "ar.off.warning": "After the expiry date the domain can be registered by someone else.",
  "ar.off.cancel": "Cancel, keep renewing",
  "ar.off.confirm": "Yes, cancel domain",
  "host.title": "Hosting",
  "host.sub": "Your hosting plans, with the specs and usage in one place.",
  "host.new": "New plan",
  "host.kpi.sites": "Active websites",
  "host.kpi.storage": "Storage in use",
  "host.kpi.traffic": "Bandwidth this month",
  "host.banner.title": "PHP 8.3 is ready for two of your sites",
  "host.banner.body": "We've already tested the upgrade on a staging copy. You can schedule it for a quiet moment in one click.",
  "host.banner.cta": "Schedule upgrade",
  "host.pkg.title": "Plans",
  "host.pkg.online": "Online",
  "host.spec.server": "Server",
  "host.spec.php": "PHP",
  "host.spec.ssl": "SSL",
  "host.spec.mailboxes": "Mailboxes",
  "host.spec.lastbackup": "Last backup",
  "host.usage.storage": "Storage",
  "host.usage.traffic": "Bandwidth",
  "host.usage.db": "Database",
  "host.manage": "Manage",
  "host.upgrade": "Upgrade plan",
  "host.ssl.valid": "Valid until",
  "host.ssl.auto": "Renews automatically",
  "host.tools.title": "Quick tools",
  "host.tools.files": "File manager",
  "host.tools.files.d": "Upload via FTP or web",
  "host.tools.db": "Database",
  "host.tools.db.d": "MySQL · phpMyAdmin",
  "host.tools.ssh": "SSH access",
  "host.tools.ssh.d": "Manage your keys",
  "host.tools.cron": "Cron jobs",
  "host.tools.cron.d": "Schedule periodic tasks",
  "host.server.title": "Servers",
  "host.server.uptime": "Uptime, 30 days",
  "host.server.location": "Eemshaven, NL",
  "host.summary.title": "Total usage",
  "host.summary.sub": "Across all plans, this month.",
  "hd.back": "All plans",
  "hd.tab.overview": "Overview",
  "hd.tab.files": "Files",
  "hd.tab.db": "Database",
  "hd.tab.ssh": "SSH",
  "hd.tab.cron": "Cron jobs",
  "hd.tab.settings": "Settings",
  "hd.kpi.uptime": "Uptime, 30 days",
  "hd.kpi.requests": "Requests today",
  "hd.kpi.errors": "Errors (24h)",
  "hd.kpi.response": "Avg. response",
  "hd.deploys": "Recent deploys",
  "hd.deploys.empty": "No deploys yet.",
  "hd.access": "Access info",
  "hd.access.ftp": "FTP / SFTP",
  "hd.access.ssh": "SSH",
  "hd.access.user": "User",
  "hd.access.host": "Host",
  "hd.access.port": "Port",
  "hd.access.path": "Webroot",
  "hd.files.upload": "Upload",
  "hd.files.new_folder": "New folder",
  "hd.files.search": "Search files…",
  "hd.files.col.name": "Name",
  "hd.files.col.size": "Size",
  "hd.files.col.modified": "Modified",
  "hd.db.create": "Create database",
  "hd.db.open": "Open in phpMyAdmin",
  "hd.db.col.name": "Database",
  "hd.db.col.size": "Size",
  "hd.db.col.users": "Users",
  "hd.db.col.engine": "Engine",
  "hd.ssh.cred": "Connection details",
  "hd.ssh.keys": "Authorized keys",
  "hd.ssh.addkey": "Add key",
  "hd.ssh.copy": "Copy command",
  "hd.ssh.key.added": "Added",
  "hd.cron.add": "Add cron job",
  "hd.cron.col.schedule": "Schedule",
  "hd.cron.col.cmd": "Command",
  "hd.cron.col.last": "Last run",
  "hd.cron.col.status": "Status",
  "hd.set.php.title": "PHP version",
  "hd.set.php.sub": "Pick the PHP version for this plan. Applied immediately to the whole site.",
  "hd.set.php.apply": "Apply version",
  "hd.set.restart.title": "Restart plan",
  "hd.set.restart.sub": "Temporarily unreachable (~30s). Only use this if the site has crashed.",
  "hd.set.restart.cta": "Restart now",
  "hd.set.danger.title": "Cancel plan",
  "hd.set.danger.sub": "Remove this plan and all files. This cannot be undone.",
  "hd.set.danger.cta": "Cancel plan",
  "hp.new.title": "New hosting plan",
  "hp.new.sub": "Pick a plan. You can upgrade later without downtime.",
  "hp.new.month": "per month",
  "hp.new.choose": "Choose this plan",
  "hp.new.popular": "Popular",
  "hp.new.feat.storage": "storage",
  "hp.new.feat.traffic": "bandwidth",
  "hp.new.feat.mail": "mailboxes",
  "hp.new.feat.db": "databases",
  "hp.new.feat.ssl": "SSL included",
  "hp.new.feat.backup": "Daily backups",
  "hp.new.feat.ssh": "SSH access",
  "hp.new.feat.staging": "Staging environment",
  "ht.scope": "For",
  "ht.files.title": "File manager",
  "ht.files.sub": "Upload and manage files for this plan.",
  "ht.db.title": "Databases",
  "ht.db.sub": "MySQL databases for this plan.",
  "ht.ssh.title": "SSH access",
  "ht.ssh.sub": "Manage authorized keys and connection details.",
  "ht.cron.title": "Cron jobs",
  "ht.cron.sub": "Schedule recurring tasks that run on the server.",
  "act.download": "Download",
  "act.rename": "Rename",
  "act.move": "Move",
  "act.permissions": "Permissions",
  "act.delete": "Delete",
  "act.open": "Open in phpMyAdmin",
  "act.export": "Export (SQL dump)",
  "act.import": "Import dump",
  "act.users": "Manage users",
  "act.copy_pub": "Copy public key",
  "act.revoke": "Revoke key",
  "act.run_now": "Run now",
  "act.edit": "Edit",
  "act.view_logs": "View logs",
  "act.pause": "Pause",
  "act.resume": "Resume",
  "act.duplicate": "Duplicate",
  "act.more": "More actions",
  "g.cancel": "Cancel",
  "g.save": "Save",
  "g.apply": "Apply",
  "g.confirm": "Confirm",
  "mod.rename.title": "Rename",
  "mod.rename.label": "New name",
  "mod.rename.save": "Rename",
  "mod.move.title": "Move",
  "mod.move.sub": "Pick the destination folder. Files are moved immediately.",
  "mod.move.current": "Current location",
  "mod.move.target": "Destination",
  "mod.move.save": "Move",
  "mod.perm.title": "Permissions",
  "mod.perm.sub": "Choose who can do what with this file. Applied immediately.",
  "mod.perm.owner": "Owner",
  "mod.perm.group": "Group",
  "mod.perm.public": "Public",
  "mod.perm.read": "Read",
  "mod.perm.write": "Write",
  "mod.perm.exec": "Execute",
  "mod.perm.octal": "Octal",
  "mod.delfile.title.file": "Delete file?",
  "mod.delfile.title.dir": "Delete folder?",
  "mod.delfile.body.file": "This file will be permanently deleted. This cannot be undone.",
  "mod.delfile.body.dir": "This folder and everything in it will be permanently deleted. This cannot be undone.",
  "mod.delfile.cta": "Yes, delete",
  "mod.deldb.title": "Delete database?",
  "mod.deldb.body": "All data, tables and users will be lost. This cannot be undone.",
  "mod.deldb.confirm": "Type the database name to confirm",
  "mod.deldb.cta": "Delete database",
  "mod.exp.title": "Export",
  "mod.exp.sub": "Create a dump you can import later or keep as a backup.",
  "mod.exp.format": "Format",
  "mod.exp.compress": "Compress (.gz)",
  "mod.exp.tables": "Tables",
  "mod.exp.tables.all": "All tables",
  "mod.exp.tables.pick": "Pick tables",
  "mod.exp.structure": "Structure",
  "mod.exp.data": "Data",
  "mod.exp.start": "Start export",
  "mod.imp.title": "Import dump",
  "mod.imp.sub": "Upload a .sql or .sql.gz file. Existing tables will be overwritten.",
  "mod.imp.drop": "Drag a file here, or click to pick",
  "mod.imp.replace": "Overwrite existing tables",
  "mod.imp.start": "Start import",
  "mod.imp.warn": "Importing overwrites data. Export first as a backup.",
  "mod.dbu.title": "Users",
  "mod.dbu.sub": "Manage which users can access this database.",
  "mod.dbu.add": "Add user",
  "mod.dbu.user": "User",
  "mod.dbu.host": "Host",
  "mod.dbu.priv": "Privileges",
  "mod.dbu.priv.ro": "Read only",
  "mod.dbu.priv.rw": "Read & write",
  "mod.dbu.priv.full": "Full access",
  "mod.dbu.new.user": "Username",
  "mod.dbu.new.pwd": "Password",
  "mod.dbu.new.pwd.gen": "Generate",
  "mod.dbu.remove": "Remove",
  "mod.revk.title": "Revoke key?",
  "mod.revk.body": "After revoking this key cannot log into the server. Existing connections stay alive until closed.",
  "mod.revk.cta": "Yes, revoke",
  "mod.cron.title.edit": "Edit cron job",
  "mod.cron.title.new": "New cron job",
  "mod.cron.preset": "Schedule",
  "mod.cron.preset.5min": "Every 5 minutes",
  "mod.cron.preset.hour": "Every hour",
  "mod.cron.preset.day": "Every night 03:00",
  "mod.cron.preset.week": "Weekly Sun 02:00",
  "mod.cron.preset.custom": "Custom schedule",
  "mod.cron.schedule": "Cron expression",
  "mod.cron.cmd": "Command",
  "mod.cron.next": "Next run",
  "mod.clog.title": "Logs",
  "mod.clog.sub": "Last 30 lines of this cron job.",
  "mod.cdel.title": "Delete cron job?",
  "mod.cdel.body": "This task won't run anymore after confirming. This cannot be undone.",
  "tst.download": "Download started",
  "tst.copied": "Copied to clipboard",
  "tst.renamed": "Renamed",
  "tst.moved": "Moved",
  "tst.perm_set": "Permissions updated",
  "tst.deleted": "Deleted",
  "tst.exported": "Export queued",
  "tst.imported": "Import started",
  "tst.user_added": "User added",
  "tst.user_removed": "User removed",
  "tst.priv_changed": "Privileges updated",
  "tst.key_revoked": "Key revoked",
  "tst.cron_run": "Cron job started",
  "tst.cron_duped": "Cron job duplicated",
  "tst.cron_paused": "Cron job paused",
  "tst.cron_resumed": "Cron job resumed",
  "tst.cron_saved": "Cron job saved",
  "tst.cron_deleted": "Cron job deleted",
  "tst.phpmyadmin": "Opening phpMyAdmin in a new tab…",
  "mod.newdir.title": "New folder",
  "mod.newdir.label": "Folder name",
  "mod.newdir.cta": "Create",
  "tst.created": "Created",
  "mod.newdb.title": "New database",
  "mod.newdb.sub": "Give the database a name. Use underscores instead of spaces.",
  "mod.newdb.label": "Name",
  "mod.newdb.cta": "Create database",
  "mod.upload.title": "Upload files",
  "mod.upload.sub": "Drag files here, or click to pick.",
  "mod.upload.target": "Destination",
  "mod.upload.start": "Start upload",
  "mod.upload.drop": "Drag files here, or click to pick",
  "tst.uploading": "Upload started",
  "mod.addkey.title": "Add SSH key",
  "mod.addkey.sub": "Paste your public key (starts with ssh-rsa, ssh-ed25519, …).",
  "mod.addkey.label": "Name",
  "mod.addkey.label.placeholder": "e.g. Work laptop",
  "mod.addkey.key": "Public key",
  "mod.addkey.cta": "Add key",
  "tst.key_added": "Key added",
  "mod.upgrade.title": "Upgrade your plan",
  "mod.upgrade.sub": "Pick a higher plan. Upgrades are instant, no downtime.",
  "mod.upgrade.current": "Current plan",
  "mod.upgrade.cta": "Upgrade now",
  "tst.upgraded": "Plan updated",
  "mod.restart.body": "The site will restart and be unreachable for about 30 seconds.",
  "mod.restart.cta": "Yes, restart",
  "tst.restarting": "Restart started…",
  "mod.canplan.body": "The plan, all files, databases and email will be deleted. This cannot be undone.",
  "mod.canplan.confirm": "Type the domain to confirm",
  "tst.canceled": "Plan cancelled",
  "mod.phpup.title": "Schedule PHP 8.3 upgrade",
  "mod.phpup.sub": "Pick when we should run the upgrade. The site is ~10 seconds unreachable during the upgrade.",
  "mod.phpup.when": "When",
  "mod.phpup.when.now": "Run now",
  "mod.phpup.when.tonight": "Tonight 03:00",
  "mod.phpup.when.weekend": "This weekend",
  "mod.phpup.sites": "Sites that will be upgraded",
  "mod.phpup.cta": "Schedule upgrade",
  "tst.upgrade_scheduled": "Upgrade scheduled",
  "tst.php_applied": "PHP version applied",
  "em.title": "Email",
  "em.sub": "Manage mailboxes, aliases, forwards and spam filters.",
  "em.new": "New address",
  "em.new.mailbox": "Mailbox",
  "em.new.alias": "Alias",
  "em.new.forward": "Forward",
  "em.new.catchall": "Catch-all",
  "em.new.mailbox.d": "Real inbox with IMAP/SMTP access.",
  "em.new.alias.d": "Extra address that arrives in an existing mailbox.",
  "em.new.forward.d": "Forward mail to an external address.",
  "em.new.catchall.d": "Catch everything for this domain in one place.",
  "em.new.helper": "What do you want to create?",
  "em.new.target": "Deliver to",
  "em.new.forward_to": "Forward to",
  "em.search": "Search mailbox or alias…",
  "em.filter.all": "All",
  "em.filter.mailbox": "Mailboxes",
  "em.filter.alias": "Aliases",
  "em.filter.forward": "Forwards",
  "em.kpi.mailboxes": "Active mailboxes",
  "em.kpi.storage": "Mail storage",
  "em.kpi.spam": "Spam blocked (24h)",
  "em.kpi.delivered": "Delivered today",
  "em.col.address": "Address",
  "em.col.type": "Type",
  "em.col.usage": "Usage",
  "em.col.last": "Last login",
  "em.col.status": "Status",
  "em.type.mailbox": "Mailbox",
  "em.type.alias": "Alias",
  "em.type.forward": "Forward",
  "em.type.catchall": "Catch-all",
  "em.status.active": "Active",
  "em.status.full": "Almost full",
  "em.status.vacation": "Vacation",
  "em.status.paused": "Paused",
  "em.group.by_domain": "Per domain",
  "em.group.flat": "Flat list",
  "em.banner.title": "Spam protection is on",
  "em.banner.body": "We blocked 1,284 messages for your domains this week. No action needed.",
  "em.banner.cta": "Spam settings",
  "ed.back": "All mailboxes",
  "ed.tab.overview": "Overview",
  "ed.tab.filters": "Filters",
  "ed.tab.forward": "Forwarding",
  "ed.tab.vacation": "Vacation",
  "ed.tab.aliases": "Aliases",
  "ed.tab.settings": "Settings",
  "ed.kpi.in": "Incoming today",
  "ed.kpi.out": "Sent today",
  "ed.kpi.spam": "Spam",
  "ed.kpi.bounce": "Bounces",
  "ed.webmail": "Open webmail",
  "ed.changepwd": "Change password",
  "ed.access.title": "Access info",
  "ed.access.imap": "IMAP",
  "ed.access.smtp": "SMTP",
  "ed.access.host": "Host",
  "ed.access.port": "Port",
  "ed.access.user": "User",
  "ed.access.security": "Security",
  "ed.recent.title": "Recent activity",
  "ed.recent.empty": "No activity in the last 7 days.",
  "ed.devices.title": "Signed-in devices",
  "ed.devices.logout": "Log out",
  "ef.title": "Filters",
  "ef.sub": "Automatically move, flag or delete messages.",
  "ef.add": "Add filter",
  "ef.col.name": "Name",
  "ef.col.when": "When",
  "ef.col.then": "Do this",
  "ef.empty.title": "No filters yet",
  "ef.empty.sub": "Create your first filter, e.g. move everything from bookings@ to the Bookings folder.",
  "ef.cond.from": "Sender contains",
  "ef.cond.subject": "Subject contains",
  "ef.cond.to": "To contains",
  "ef.cond.body": "Body contains",
  "ef.act.folder": "Move to folder",
  "ef.act.label": "Add label",
  "ef.act.flag": "Mark as important",
  "ef.act.delete": "Delete immediately",
  "ef.act.forward": "Forward to",
  "evf.title": "Forwarding",
  "evf.sub": "Automatically forward incoming mail to another address.",
  "evf.on": "Forwarding on",
  "evf.to": "To",
  "evf.keep": "Keep a copy in this mailbox",
  "evf.add_to": "Add address",
  "evf.empty": "Add at least one address to forward to.",
  "ev.title": "Vacation reply",
  "ev.sub": "Send an automatic reply when you're not available.",
  "ev.on": "Vacation reply on",
  "ev.from": "From",
  "ev.until": "Until",
  "ev.subject": "Subject",
  "ev.message": "Message",
  "ev.once": "Once per sender",
  "ea.title": "Aliases",
  "ea.sub": "Extra addresses that arrive in this mailbox.",
  "ea.add": "Add alias",
  "ea.col.alias": "Alias",
  "ea.col.target": "Arrives in",
  "ea.empty.title": "No aliases",
  "ea.empty.sub": "Create info@ or contact@ as an alias for this mailbox.",
  "es.title": "Settings",
  "es.quota.title": "Storage quota",
  "es.quota.sub": "Maximum size for this mailbox.",
  "es.spam.title": "Spam filter",
  "es.spam.sub": "How strict should we be with spam.",
  "es.spam.strict": "Strict",
  "es.spam.balanced": "Balanced",
  "es.spam.lenient": "Lenient",
  "es.smtp.title": "Allow external SMTP",
  "es.smtp.sub": "Send through this mailbox from external devices.",
  "es.danger.title": "Delete mailbox",
  "es.danger.sub": "Delete this mailbox and all its messages. Cannot be undone.",
  "es.danger.cta": "Delete mailbox",
  "mod.nm.title": "New mailbox",
  "mod.nm.sub": "Create a mailbox for one of your domains.",
  "mod.nm.local": "Address",
  "mod.nm.domain": "Domain",
  "mod.nm.pwd": "Password",
  "mod.nm.pwd.gen": "Generate",
  "mod.nm.quota": "Quota",
  "mod.nm.cta": "Create mailbox",
  "mod.pwd.title": "Change password",
  "mod.pwd.sub": "The new password is immediately active. Signed-in clients have to log in again.",
  "mod.pwd.new": "New password",
  "mod.pwd.confirm": "Confirm password",
  "mod.pwd.show": "Show",
  "mod.pwd.hide": "Hide",
  "mod.pwd.cta": "Save password",
  "mod.pwd.mismatch": "Passwords don't match.",
  "mod.pwd.weak": "Password is too weak. Use at least 10 characters.",
  "mod.alias.title": "Add alias",
  "mod.alias.sub": "Create a new address that arrives in this mailbox.",
  "mod.alias.local": "Alias",
  "mod.alias.domain": "Domain",
  "mod.alias.cta": "Create alias",
  "mod.efilter.title.edit": "Edit filter",
  "mod.efilter.title.new": "New filter",
  "mod.efilter.name": "Name",
  "mod.efilter.if": "If",
  "mod.efilter.value": "Value",
  "mod.efilter.then": "Do this",
  "mod.efilter.cta": "Save filter",
  "mod.delmb.title": "Delete mailbox?",
  "mod.delmb.body": "All messages will be lost. This cannot be undone.",
  "mod.delmb.confirm": "Type the address to confirm",
  "mod.delmb.cta": "Delete mailbox",
  "eact.webmail": "Open webmail",
  "eact.pwd": "Change password",
  "eact.forward": "Set forwarding",
  "eact.vacation": "Set vacation",
  "eact.alias": "Add alias",
  "eact.pause": "Pause mailbox",
  "eact.resume": "Resume mailbox",
  "eact.delete": "Delete",
  "tst.mb_created": "Mailbox created",
  "tst.mb_deleted": "Mailbox deleted",
  "tst.pwd_changed": "Password changed",
  "tst.alias_added": "Alias added",
  "tst.alias_removed": "Alias removed",
  "tst.filter_saved": "Filter saved",
  "tst.filter_deleted": "Filter deleted",
  "tst.vacation_on": "Vacation reply on",
  "tst.vacation_off": "Vacation reply off",
  "tst.forward_on": "Forwarding enabled",
  "tst.forward_off": "Forwarding disabled",
  "tst.mb_paused": "Mailbox paused",
  "tst.mb_resumed": "Mailbox resumed",
  "tst.webmail": "Opening webmail in a new tab…",
  "mod.edit_alias.title.alias": "Edit alias",
  "mod.edit_alias.title.forward": "Edit forward",
  "mod.edit_alias.title.catchall": "Edit catch-all",
  "mod.edit_alias.from": "Address",
  "mod.edit_alias.to": "Delivers to",
  "mod.edit_alias.to.external": "Forward to",
  "tst.edited": "Updated",
  "spam.title": "Spam settings",
  "spam.sub": "How strict should we filter spam for all your domains?",
  "spam.level": "Filter level",
  "spam.lvl.strict": "Strict",
  "spam.lvl.strict.d": "Anything mildly suspicious is blocked. Some false positives.",
  "spam.lvl.balanced": "Balanced",
  "spam.lvl.balanced.d": "Recommended. Spam to spam folder, uncertain mail labelled.",
  "spam.lvl.lenient": "Lenient",
  "spam.lvl.lenient.d": "Only block obvious spam. More mail in your inbox, including spam.",
  "spam.greylist": "Greylisting",
  "spam.greylist.d": "Bounce unknown senders once. Effective against bots; slightly delays delivery.",
  "spam.blocklist": "Block list",
  "spam.blocklist.add": "Add address or domain",
  "spam.allowlist": "Allow list",
  "spam.allowlist.add": "Add address or domain",
  "spam.scope": "Applies to",
  "spam.scope.all": "All domains",
  "spam.scope.pick": "Per domain",
  "tst.spam_saved": "Spam settings saved",
  "mod.devlogout.title": "Sign out device?",
  "mod.devlogout.body": "The device has to sign in again before it can reach this mailbox.",
  "mod.devlogout.cta": "Yes, sign out",
  "tst.dev_logged_out": "Device signed out",
  "bk.title": "Backups",
  "bk.sub": "Automatic daily backups for all your sites and mailboxes. Roll back to any earlier point in seconds.",
  "bk.new": "Run backup now",
  "bk.schedule": "Edit schedule",
  "bk.kpi.last": "Last backup",
  "bk.kpi.success": "Successful (30d)",
  "bk.kpi.storage": "Backup storage",
  "bk.kpi.retention": "Retention",
  "bk.banner.title": "All clear. Backups completed yesterday 04:12.",
  "bk.banner.body": "3 sites and 9 mailboxes safely captured. No action needed.",
  "bk.banner.cta": "Activity log",
  "bk.list.title": "Per site",
  "bk.col.site": "Site",
  "bk.col.last": "Last backup",
  "bk.col.snapshots": "Snapshots",
  "bk.col.size": "Size",
  "bk.col.next": "Next backup",
  "bk.col.status": "Status",
  "bk.status.healthy": "Healthy",
  "bk.status.warn": "Needs attention",
  "bk.status.running": "Running",
  "bk.snapshots.title": "Snapshots",
  "bk.snapshots.sub": "Each snapshot contains files, databases and mailboxes at that moment.",
  "bk.snap.col.when": "When",
  "bk.snap.col.kind": "Type",
  "bk.snap.col.size": "Size",
  "bk.snap.col.includes": "Contents",
  "bk.snap.col.retention": "Kept until",
  "bk.snap.kind.daily": "Daily",
  "bk.snap.kind.weekly": "Weekly",
  "bk.snap.kind.monthly": "Monthly",
  "bk.snap.kind.manual": "Manual",
  "bk.snap.kind.predeploy": "Pre-deploy",
  "bk.tab.snapshots": "Snapshots",
  "bk.tab.settings": "Settings",
  "bk.tab.activity": "Activity",
  "bk.act.restore": "Restore",
  "bk.act.download": "Download (.zip)",
  "bk.act.contents": "View contents",
  "bk.act.lock": "Keep longer",
  "bk.act.unlock": "Stop keeping",
  "bk.act.delete": "Delete snapshot",
  "bk.set.freq.title": "Frequency",
  "bk.set.freq.sub": "How often we run automatic backups.",
  "bk.set.freq.hourly": "Hourly",
  "bk.set.freq.daily": "Daily",
  "bk.set.freq.twice": "Twice a day",
  "bk.set.ret.title": "Retention",
  "bk.set.ret.sub": "How long we keep each kind of snapshot.",
  "bk.set.ret.daily": "Daily",
  "bk.set.ret.weekly": "Weekly",
  "bk.set.ret.monthly": "Monthly",
  "bk.set.scope.title": "What's in a backup",
  "bk.set.scope.sub": "Disable parts you'd rather not capture.",
  "bk.set.scope.files": "Files",
  "bk.set.scope.db": "Databases",
  "bk.set.scope.mail": "Mailboxes",
  "bk.set.offsite.title": "Off-site replication",
  "bk.set.offsite.sub": "Second copy in a different datacenter (Eemshaven → Groningen).",
  "bk.includes.files": "Files",
  "bk.includes.db": "Databases",
  "bk.includes.mail": "Mailboxes",
  "bk.activity.title": "Activity",
  "bk.activity.empty": "No activity yet this week.",
  "mod.restore.title": "Restore snapshot",
  "mod.restore.sub": "Pick what to restore and where. We'll take one more safety snapshot first.",
  "mod.restore.what": "What to restore",
  "mod.restore.what.all": "Everything",
  "mod.restore.what.files": "Files only",
  "mod.restore.what.db": "Databases only",
  "mod.restore.what.mail": "Mailboxes only",
  "mod.restore.where": "Where",
  "mod.restore.where.live": "Restore to live site",
  "mod.restore.where.staging": "Restore to staging",
  "mod.restore.dry": "Dry-run: show what would change, don't apply",
  "mod.restore.cta": "Start restore",
  "mod.restore.warn": "Restoring overwrites the current files and databases. Take a manual backup first if you want to be safe.",
  "mod.restore.files.title": "Files",
  "mod.restore.files.all": "All files",
  "mod.restore.files.pick": "Pick folders",
  "mod.restore.files.hint": "Tick folders/files to only restore those.",
  "mod.restore.db.title": "Databases",
  "mod.restore.db.all": "All databases",
  "mod.restore.db.pick": "Pick databases",
  "mod.restore.mail.title": "Mailboxes",
  "mod.restore.mail.all": "All mailboxes",
  "mod.restore.mail.pick": "Pick mailboxes",
  "mod.restore.where.sub": "To subdomain",
  "mod.restore.sub.label": "Subdomain",
  "mod.restore.sub.help": "We restore the snapshot to a temporary copy. Your live site stays untouched.",
  "mod.restore.sub.preview": "Will be reachable at",
  "mod.restore.summary": "Will be restored",
  "mod.restore.summary.empty": "Pick at least one part above.",
  "mod.bnow.title": "Run a backup now",
  "mod.bnow.sub": "Capture a manual snapshot. Useful before a major change.",
  "mod.bnow.scope": "What to include",
  "mod.bnow.label": "Label (optional)",
  "mod.bnow.label.ph": "e.g. Before PHP 8.3 upgrade",
  "mod.bnow.lock": "Don't auto-cleanup",
  "mod.bnow.cta": "Start backup",
  "mod.snap.title": "Snapshot contents",
  "mod.snap.files": "Files",
  "mod.snap.db": "Databases",
  "mod.snap.mail": "Mailboxes",
  "mod.snap.size": "Size",
  "mod.snap.count": "Count",
  "mod.snap.kind": "Type",
  "mod.snap.created": "Created",
  "mod.delsnap.title": "Delete snapshot?",
  "mod.delsnap.body": "The snapshot will be deleted right away. Other snapshots stay available.",
  "tst.backup_started": "Backup started",
  "tst.backup_done": "Backup completed",
  "tst.restore_started": "Restore started",
  "tst.snapshot_locked": "Snapshot pinned",
  "tst.snapshot_unlocked": "Snapshot unpinned",
  "tst.snapshot_deleted": "Snapshot deleted",
  "tst.schedule_saved": "Schedule saved",
  "bl.title": "Billing",
  "bl.sub": "Invoices, payment methods and subscriptions in one place.",
  "bl.pay": "Pay outstanding",
  "bl.pay_method": "Change payment method",
  "bl.address": "Billing address",
  "bl.kpi.open": "Outstanding",
  "bl.kpi.this_month": "This month",
  "bl.kpi.next": "Next invoice",
  "bl.kpi.method": "Payment method",
  "bl.banner.title": "Save 5% with SEPA direct debit",
  "bl.banner.body": "We auto-charge on the due date. Switch in one click.",
  "bl.banner.cta": "Enable direct debit",
  "bl.invoices.title": "Recent invoices",
  "bl.invoices.viewall": "View all",
  "bl.col.number": "Invoice number",
  "bl.col.date": "Date",
  "bl.col.amount": "Amount",
  "bl.col.due": "Due date",
  "bl.col.status": "Status",
  "bl.status.paid": "Paid",
  "bl.status.open": "Outstanding",
  "bl.status.overdue": "Overdue",
  "bl.status.draft": "Draft",
  "bl.subs.title": "Subscriptions",
  "bl.subs.cancel": "Cancel",
  "bl.subs.viewall": "Manage subscriptions",
  "bl.methods.title": "Payment methods",
  "bl.methods.add": "Add method",
  "bl.methods.primary": "Primary",
  "bl.methods.set_primary": "Set as primary",
  "bl.methods.remove": "Remove",
  "bl.address.title": "Billing address",
  "bl.address.edit": "Edit",
  "bd.back": "All invoices",
  "bd.invoice": "Invoice",
  "bd.items.title": "Line items",
  "bd.items.col.desc": "Description",
  "bd.items.col.period": "Period",
  "bd.items.col.qty": "Qty",
  "bd.items.col.price": "Unit price",
  "bd.items.col.amount": "Amount",
  "bd.items.subtotal": "Subtotal",
  "bd.items.vat": "VAT (21%)",
  "bd.items.total": "Total",
  "bd.actions.download": "Download PDF",
  "bd.actions.send": "Send copy",
  "bd.actions.print": "Print",
  "bd.actions.pay": "Pay now",
  "bd.history.title": "Timeline",
  "bd.notes.title": "Notes",
  "bd.notes.empty": "No notes on this invoice.",
  "mod.pay.title": "Pay invoice",
  "mod.pay.sub": "Choose a payment method. The amount is settled immediately.",
  "mod.pay.amount": "Amount",
  "mod.pay.method": "Method",
  "mod.pay.cta": "Pay now",
  "mod.pm.title": "Add payment method",
  "mod.pm.sub": "Pick a payment method. We store it safely for recurring charges.",
  "mod.pm.kind": "Type",
  "mod.pm.kind.ideal": "iDEAL",
  "mod.pm.kind.card": "Credit card",
  "mod.pm.kind.sepa": "SEPA direct debit",
  "mod.pm.bank": "Bank",
  "mod.pm.iban": "IBAN",
  "mod.pm.holder": "Account holder",
  "mod.pm.card.num": "Card number",
  "mod.pm.card.exp": "Expires",
  "mod.pm.card.cvc": "CVC",
  "mod.pm.cta": "Add method",
  "mod.pm.set_primary": "Make primary method",
  "mod.addr.title": "Edit billing address",
  "mod.addr.company": "Company",
  "mod.addr.attn": "Attn",
  "mod.addr.street": "Street",
  "mod.addr.zip": "Postcode",
  "mod.addr.city": "City",
  "mod.addr.country": "Country",
  "mod.addr.vat": "VAT number",
  "mod.addr.email": "Invoice email",
  "mod.addr.cta": "Save",
  "mod.canceluse.title": "Cancel subscription?",
  "mod.canceluse.body": "The subscription stays active until the end of the current period. After that the plan is deactivated.",
  "mod.canceluse.cta": "Yes, cancel",
  "tst.invoice_paid": "Invoice paid",
  "tst.payment_started": "Payment started",
  "tst.method_added": "Method added",
  "tst.method_removed": "Method removed",
  "tst.method_primary": "Primary method updated",
  "tst.address_saved": "Address saved",
  "tst.subscription_canceled": "Subscription canceled",
  "tst.invoice_sent": "Invoice sent",
  "tst.print": "Opening print dialog…",
  "dd.nameservers": "Nameservers",
  "dd.lock": "Transfer lock",
  "dd.linked.title": "Linked services",
  "dns.simple": "Simple mode",
  "dns.advanced": "Advanced",
  "dns.tasks.title": "What do you want to do?",
  "dns.tasks.sub": "Pick a common task and we'll configure the DNS records for you.",
  "dns.task.website": "Point to my website",
  "dns.task.website.d": "Set A and CNAME records so visitors reach your site.",
  "dns.task.mail": "My email runs through…",
  "dns.task.mail.d": "Configure MX records for Google Workspace, Microsoft 365 or DMRS Mail.",
  "dns.task.verify": "Verify a service",
  "dns.task.verify.d": "Add a TXT record to prove ownership (Google, Meta, …).",
  "dns.task.forward": "Forward to another URL",
  "dns.task.forward.d": "Redirect visitors of this domain to e.g. example.com.",
  "dns.records.title": "All DNS records",
  "dns.records.add": "Add record",
  "dns.records.help": "Not sure? Use simple mode above.",
  "dns.col.type": "Type",
  "dns.col.name": "Name",
  "dns.col.value": "Value",
  "dns.col.ttl": "TTL",
  "tw.title": "Point {domain} to your website",
  "tw.sub": "Pick where your site is hosted. We'll set the right DNS records.",
  "tw.opt.dmrs": "DMRS Hosting (this customer)",
  "tw.opt.ip": "Another IP address",
  "tw.opt.host": "Another hostname (e.g. mysite.netlify.app)",
  "tw.cancel": "Cancel",
  "tw.apply": "Apply",
  "tw.preview": "We will create these records:",
  "mr.title": "Email routing",
  "mr.sub": "Decide which server receives email for this domain.",
  "mr.current": "Current setup",
  "mr.change": "Change provider",
  "mr.preset.dmrs": "DMRS Mail",
  "mr.preset.dmrs.d": "Included with your hosting plan. 6 mailboxes active.",
  "mr.preset.google": "Google Workspace",
  "mr.preset.google.d": "Gmail for your domain. Requires a Workspace account.",
  "mr.preset.ms": "Microsoft 365",
  "mr.preset.ms.d": "Outlook for your domain. Requires an M365 account.",
  "mr.preset.none": "No email",
  "mr.preset.none.d": "Don't receive email on this domain. Removes MX records.",
  "mr.preset.custom": "Other provider",
  "mr.preset.custom.d": "Enter your own MX records (e.g. Fastmail, ProtonMail).",
  "mr.deliverability": "Deliverability",
  "mr.spf": "SPF",
  "mr.dkim": "DKIM",
  "mr.dmarc": "DMARC",
  "mr.healthy": "Looks good",
  "fw.title": "Forwarding",
  "fw.sub": "Automatically redirect visitors to another URL.",
  "fw.add": "Add forward",
  "fw.col.from": "From",
  "fw.col.to": "To",
  "fw.col.type": "Type",
  "fw.col.code": "Status code",
  "fw.type.permanent": "Permanent",
  "fw.type.temporary": "Temporary",
  "fw.empty.title": "No forwards yet",
  "fw.empty.sub": "Forward the entire domain to another address, or /blog to your Medium.",
  "ds.title": "Settings",
  "ds.sub": "Contact details, nameservers and domain transfer.",
  "ds.contact.title": "Contact details",
  "ds.contact.sub": "Used for WHOIS and official messages from the registry.",
  "ds.contact.edit": "Edit contacts",
  "ds.ns.title": "Nameservers",
  "ds.ns.sub": "By default these point to DMRS nameservers. Only change if you know what you're doing.",
  "ds.ns.use_dmrs": "Use DMRS nameservers",
  "ds.ns.custom": "Custom nameservers",
  "ds.danger.title": "Transfer domain",
  "ds.danger.sub": "Request a transfer code to move this domain to another registrar.",
  "ds.danger.get": "Request transfer code",
  "ds.dnssec.title": "DNSSEC",
  "ds.dnssec.sub": "Protects DNS responses against forgery. Recommended.",
  "ds.dnssec.active": "DNSSEC active",
  "ds.dnssec.algo": "Algorithm",
  "ds.dnssec.keytag": "Key tag",
  "ds.dnssec.ds": "DS record",
  "ds.dnssec.keys.title": "Custom DS records",
  "ds.dnssec.keys.sub": "Add the DS records from your external DNS provider.",
  "ds.dnssec.keys.add": "Add DS record",
  "ds.dnssec.keys.empty": "No custom DS records yet. DMRS manages the keys.",
  "mod.dnssec.title": "Add DS record",
  "mod.dnssec.keytag": "Key tag",
  "mod.dnssec.algo": "Algorithm",
  "mod.dnssec.digestType": "Digest type",
  "mod.dnssec.digest": "Digest",
  "mod.dnssec.cta": "Add DS record",
  "tst.ds_added": "DS record added",
  "tst.ds_removed": "DS record removed",
  "mod.contacts.title": "Edit contacts",
  "mod.contacts.sub": "Holder and technical contact are used for WHOIS and official messages from the registry.",
  "mod.contacts.role.holder": "Holder",
  "mod.contacts.role.tech": "Technical contact",
  "mod.contacts.role.admin": "Administrative contact",
  "mod.contacts.role.billing": "Billing contact",
  "mod.contacts.name": "Name",
  "mod.contacts.email": "Email",
  "mod.contacts.phone": "Phone",
  "mod.contacts.handle": "Handle",
  "mod.contacts.handle.ph": "e.g. JANS001",
  "mod.contacts.handle.search": "Look up handle",
  "mod.contacts.handle.searching": "Searching…",
  "mod.contacts.handle.notfound": "No handle found — enter manually.",
  "mod.contacts.handle.help": "Registry handle of this contact. Auto-fetched later.",
  "tst.contacts_saved": "Contacts saved",
  "mod.transfer.method": "Receive code via",
  "mod.transfer.method.email": "Secure email",
  "mod.transfer.method.sms": "SMS to registered number",
  "mod.transfer.method.email.d": "We send the code to your holder address. Safer: not shown in the panel.",
  "mod.transfer.dnssec.title": "Turn DNSSEC off first",
  "mod.transfer.dnssec.body": "Most transfers fail because DNSSEC is still active at the old registrar. Disable it here so the new registrar can re-establish it.",
  "mod.transfer.dnssec.cta": "Disable DNSSEC",
  "mod.transfer.dnssec.skip": "Keep DNSSEC on",
  "mod.transfer.send": "Send transfer code",
  "tst.transfer_sent": "Transfer code sent to your email",
  "ds.ns.save": "Save nameservers",
  "ds.ns.invalid": "Enter at least 2 valid nameservers.",
  "mod.ns.title": "Change nameservers?",
  "mod.ns.body": "A change can take up to 24h to take effect globally. During that period your site or email may be briefly unreachable.",
  "mod.ns.cta": "Yes, change nameservers",
  "tst.ns_saved": "Nameservers saved",
  "tst.dnssec_on": "DNSSEC enabled",
  "tst.dnssec_off": "DNSSEC disabled",
  "mod.transfer.title": "Request transfer code",
  "mod.transfer.sub": "Hand this code to your new registrar to move this domain over.",
  "mod.transfer.code": "Transfer code",
  "mod.transfer.warn": "Once the transfer starts you cannot make changes here. Cancel any pending changes first.",
  "mod.transfer.copy": "Copy code",
  "mod.transfer.email": "Send to my email",
  "tst.transfer_code": "Transfer code regenerated",
  "mm.title": "My email runs through…",
  "mm.sub": "Pick your provider. We'll set the right MX records for you.",
  "mm.confirm": "Replace MX records now",
  "vm.title": "Verify a service",
  "vm.sub": "Many services ask you to add a TXT record to prove this domain is yours.",
  "vm.svc": "Which service?",
  "vm.token": "Verification token",
  "vm.token.placeholder": "Paste the token from Google Search Console or another service",
  "vm.create": "Create TXT record",
  "fwm.title": "Forward to another URL",
  "fwm.from": "From (this domain)",
  "fwm.to": "To (full URL)",
  "fwm.kind.full": "Entire domain",
  "fwm.kind.path": "Specific path",
  "fwm.kind.title": "What do you want to forward?",
  "fwm.code": "Status code",
  "fwm.code.301": "301 — Permanent (recommended)",
  "fwm.code.302": "302 — Temporary",
  "fwm.create": "Create forward",
  "rec.add.title": "Add DNS record",
  "rec.edit.title": "Edit DNS record",
  "rec.type": "Type",
  "rec.name": "Name",
  "rec.name.help": "Use @ for the root domain. E.g. www, mail or api.",
  "rec.value": "Value",
  "rec.value.help.A": "An IPv4 address, e.g. 185.182.56.42",
  "rec.value.help.AAAA": "An IPv6 address, e.g. 2a01:7c8::1",
  "rec.value.help.CNAME": "A hostname this should point to.",
  "rec.value.help.MX": "Priority (lower = more important) followed by the mail server, e.g. 10 mail.dmrs.nl",
  "rec.value.help.TXT": "Free text, often used for verification and mail (SPF, DKIM, DMARC).",
  "rec.value.help.SRV": "Priority, weight, port and target — e.g. 10 100 443 sip.example.com",
  "rec.ttl": "TTL (seconds)",
  "rec.ttl.help": "How long other servers may cache this record. 3600 (1 hour) is standard.",
  "rec.prio": "Priority",
  "rec.save": "Save",
  "rec.delete": "Delete record",
  "rec.delete.confirm": "Are you sure you want to delete this record?",
  "common.loading": "Loading…",
  "format.justNow": "just now",
  "format.perMonth": "{amount}/mo",
  "invoiceStatus.paid": "Paid",
  "invoiceStatus.open": "Open",
  "invoiceStatus.overdue": "Overdue",
  "invoiceStatus.failed": "Payment failed",
  "invoiceStatus.cancelled": "Cancelled",
  "hostingStatus.active": "Active",
  "hostingStatus.suspended": "Suspended",
  "hostingStatus.terminated": "Terminated",
  "hostingStatus.pending": "Being set up",
  "hostingStatus.pending_cancellation": "Cancelling",
  "health.healthy": "Online",
  "health.degraded": "Degraded",
  "health.down": "Down",
  "health.unknown": "Active",
  "health.checked": "Checked {time}",
  "notif.invoice.overdue": "Invoice {number} is overdue",
  "notif.invoice.failed": "Payment for {number} failed",
  "notif.invoice.open": "Invoice {number} is open",
  "notif.invoice.body": "{amount} · due {date}",
  "notif.hosting.suspended": "{domain} is suspended",
  "notif.hosting.suspended.body": "Contact us or pay open invoices.",
  "notif.hosting.pending": "{domain} is being set up",
  "notif.hosting.pending.body": "We'll let you know as soon as it's ready.",
  "notif.hosting.down": "{domain} is down",
  "notif.hosting.down.body": "We're looking into it. See the hosting for details.",
  "domainError.empty": "Enter a domain name.",
  "domainError.url": "Enter just the domain name, without http:// or a path (e.g. example.com).",
  "domainError.email": "This looks like an email address. Enter just the domain name.",
  "domainError.space": "A domain name cannot contain spaces.",
  "domainError.www": "Leave out \"www.\"; we set that up automatically.",
  "domainError.no_tld": "Add the extension, for example .com or .nl.",
  "domainError.too_long": "This domain name is too long (253 characters max).",
  "domainError.empty_label": "There are two dots in a row or a dot at the start.",
  "domainError.label_too_long": "Each part between dots can be at most 63 characters.",
  "domainError.tld": "This extension is not valid.",
  "domainError.chars": "Use only letters, digits and hyphens.",
  "domainError.hyphen": "A domain name cannot start or end with a hyphen.",
  "lang.label": "Language",
  "domainsPage.loadError": "Couldn't load domains",
  "domainsPage.notFound": "Domain not found",
  "domainsPage.search": "Search domain…",
  "domainsPage.filter.pending": "Pending",
  "domainsPage.dnsPick.title": "Add a DNS record",
  "domainsPage.dnsPick.none": "You don't have any domains yet. Add a domain first.",
  "domainsPage.dnsPick.choose": "Pick the domain you want to add a record to below.",
  "domainsPage.dismiss": "Dismiss",
  "domainsPage.empty": "No domains found.",
  "domainsPage.notLinked": "Not linked",
  "domainsPage.autoRenew.on": "Auto-renew on",
  "domainsPage.autoRenew.off": "Auto-renew off",
  "domainsPage.status.active": "Active",
  "domainsPage.status.pending": "Pending",
  "domainsPage.status.transferring": "Transferring",
  "domainsPage.status.expired": "Expired",
  "domainsPage.status.suspended": "Suspended",
  "domainsPage.status.cancelled": "Cancelled",
  "domainsPage.status.unknown": "Unknown",
  "domainsPage.days.expired": "expired",
  "domainsPage.days.today": "today",
  "domainsPage.days.one": "in 1 day",
  "domainsPage.days.other": "in {n} days",
  "addDomain.duplicate": "This domain is already in your account.",
  "addDomain.requested": "{domain} has been requested",
  "addDomain.exists": "This domain is already registered in our system.",
  "addDomain.confirm.title": "Confirm registration",
  "addDomain.confirm.description": "Check the details. Once you confirm, the registration is requested.",
  "addDomain.back": "Back",
  "addDomain.working": "Working…",
  "addDomain.register": "Register domain",
  "addDomain.term": "Term",
  "addDomain.cost": "Cost",
  "addDomain.cost.value": "At the current rate for {tld}; the amount appears on your next invoice.",
  "addDomain.next": "Next",
  "addDomain.name": "Domain name",
  "addDomain.name.hint": "The full domain name including the extension (.com, .nl, .eu, …).",
  "addDomain.name.placeholder": "example.com",
  "emailList.domains.one": "{n} domain",
  "emailList.domains.other": "{n} domains",
  "emailList.kpi.allocated": "allocated total",
  "emailList.kpi.noMetric": "No metric",
  "emailList.search": "Search mailbox…",
  "emailList.group.byDomain": "By domain",
  "emailList.group.flat": "Flat",
  "emailList.loadError": "Couldn't load mailboxes",
  "emailList.empty.title": "No mailboxes yet",
  "emailList.empty.body": "Create your first mailbox.",
  "emailList.noResults.title": "No mailboxes found",
  "emailList.noResults.body": "Adjust your search or filter.",
  "emailList.addresses.one": "{n} address",
  "emailList.addresses.other": "{n} addresses",
  "emailList.status.suspended": "Suspended",
  "emailList.status.pending": "Pending",
  "emailList.status.disabled": "Disabled",
  "emailList.new.localError": "Before the @ use only letters, digits and . _ - + (not at the start or end).",
  "mailDomain.add": "Add email domain",
  "mailDomain.description": "Choose a domain or hosting package on your account. We set up the mail server and the DNS records (MX, SPF, DKIM, DMARC) for you.",
  "mailDomain.activate": "Activate email",
  "mailDomain.stop": "Turn off email",
  "mailDomain.stopHint": "Turn off email with us to move to another mail provider.",
  "mailDomain.stopTitle": "Turn off email for {domain}?",
  "mailDomain.stopBody": "All {n} mailboxes, aliases and their messages are deleted permanently, and the mail records (MX, SPF, DKIM) are removed from DNS. This cannot be undone.",
  "mailDomain.stopped": "Email for {domain} has been turned off.",
  "mailDomain.activated": "Email activated for {domain}",
  "mailDomain.none": "Every domain already has email. Add a domain or hosting package first.",
  "mailDomain.firstActivate": "You have no email domain yet.",
  "mailDomain.routingHint": "Want mailboxes on this domain with us? Activate email and we set up the mail server and the DNS records for you.",
  "mailDomain.err.notOwned": "This domain is not on your account. Add the domain or a hosting package for it first.",
  "mailDomain.err.exists": "Email is already active for this domain.",
  "emailList.new.chooseDomain": "— Choose domain —",
  "emailList.new.username": "Username (before @)",
  "emailList.new.quota": "Quota (MB)",
  "emailDetail.working": "Working…",
  "emailDetail.create": "Create",
  "emailDetail.delete": "Delete",
  "emailDetail.change": "Change",
  "emailDetail.off": "Off",
  "emailDetail.notFound": "Mailbox not found",
  "emailDetail.quota": "Quota",
  "emailDetail.forward.keepCopy": "{address} (keep copy)",
  "emailDetail.client.title": "Mail client settings",
  "emailDetail.client.unavailable": "Server details are not available for this domain yet.",
  "emailDetail.pw.min": "At least 12 characters.",
  "emailDetail.pw.mismatch": "Passwords do not match.",
  "emailDetail.forward.saved": "Forwarding saved",
  "emailDetail.forward.desc": "Forward incoming mail to another address.",
  "emailDetail.forward.on": "Forwarding on",
  "emailDetail.forward.to": "Forward to",
  "emailDetail.invalidEmail": "Not a valid email address.",
  "emailDetail.forward.placeholder": "name@example.com",
  "emailDetail.forward.keep": "Keep a copy in this mailbox",
  "emailDetail.vacation.defaultSubject": "Out of office",
  "emailDetail.vacation.saved": "Out-of-office saved",
  "emailDetail.vacation.title": "Out-of-office",
  "emailDetail.vacation.desc": "Send an automatic reply during a vacation or absence.",
  "emailDetail.vacation.on": "Out-of-office on",
  "emailDetail.vacation.placeholder": "For example: I am away until Monday and will reply as soon as possible after that.",
  "emailDetail.aliases.desc": "Additional addresses that deliver to this mailbox.",
  "emailDetail.aliases.empty.title": "No aliases yet",
  "emailDetail.aliases.empty.body": "Create e.g. info@ or contact@ as an alias for this mailbox.",
  "emailDetail.aliases.deleteAria": "Delete {address}",
  "emailDetail.aliases.added": "Alias added",
  "emailDetail.aliases.deleted": "Alias deleted",
  "emailDetail.aliases.confirmTitle": "Delete alias?",
  "emailDetail.aliases.confirmBody": "Mail to {address} will no longer be delivered.",
  "emailDetail.aliasModal.deliversTo": "Incoming mail will arrive at {address}",
  "emailDetail.aliasModal.label": "Alias (part before @)",
  "emailDetail.aliasModal.name": "name",
  "emailDetail.aliasModal.invalid": "Only letters, digits and . _ + -",
  "emailDetail.quota.saved": "Quota updated",
  "emailDetail.quota.title": "Storage quota",
  "emailDetail.quota.desc": "Maximum space for this mailbox.",
  "emailDetail.danger.title": "Danger zone",
  "emailDetail.danger.desc": "Deleting a mailbox is permanent. All mail and settings will be lost.",
  "emailDetail.danger.confirmBody": "Permanently delete {address}?",
  "emailDetail.deleted": "Mailbox deleted",
  "emailDetail.spam.saved": "Spam filter saved",
  "emailDetail.spam.lenient": "Lenient",
  "emailDetail.spam.desc": "How strict should the spam filter be?",
  "dashboard.greeting.night": "Good night",
  "dashboard.greeting.night.named": "Good night, {name}",
  "dashboard.greeting.morning": "Good morning",
  "dashboard.greeting.morning.named": "Good morning, {name}",
  "dashboard.greeting.afternoon": "Good afternoon",
  "dashboard.greeting.afternoon.named": "Good afternoon, {name}",
  "dashboard.greeting.evening": "Good evening",
  "dashboard.greeting.evening.named": "Good evening, {name}",
  "dashboard.sites.error": "Couldn't load your websites",
  "dashboard.sites.empty": "No hosting yet",
  "dashboard.sites.empty.body": "Order a hosting plan to get started.",
  "dashboard.usage.none": "Not measured yet",
  "dashboard.activity.empty": "No activity yet.",
  "detailUi.working": "Working…",
  "detailUi.notFound": "Not found",
  "detailUi.loadFailed": "Could not load",
  "detailUi.retry": "Try again",
  "newPlan.title": "New hosting plan",
  "newPlan.description": "Pick a package and link a domain.",
  "newPlan.created": "Hosting created",
  "newPlan.create": "Create",
  "newPlan.packages.error": "Packages couldn't be loaded. {error}",
  "newPlan.domain.placeholder": "example.com",
  "newPlan.package": "Package",
  "newPlan.packages.loading": "Loading packages…",
  "newPlan.package.choose": "— Choose a package —",
  "hostingList.onServers.one": "on {n} server",
  "hostingList.onServers.other": "on {n} servers",
  "hostingList.storage.allocated": "allocated total",
  "hostingList.traffic.none": "no metric",
  "hostingList.error": "Couldn't load hosting",
  "hostingList.empty": "No hosting",
  "hostingList.empty.body": "Add your first plan to get started.",
  "hostingList.servers.none": "No server information available.",
  "hostingList.sites.one": "{n} site",
  "hostingList.sites.other": "{n} sites",
  "hostingList.addPlanFirst": "Add a plan first",
  "hostingList.serverStatus.online": "Online",
  "hostingList.serverStatus.offline": "Offline",
  "hostingList.serverStatus.provisioning": "Being set up",
  "hostingList.serverStatus.error": "Error",
  "hostingDetail.notFound": "Hosting not found",
  "hostingDetail.tab.access": "SFTP access",
  "hostingDetail.ssl.settingUp": "SSL is being set up",
  "hostingDetail.price": "Price",
  "hostingDetail.storage": "Storage",
  "hostingDetail.memory": "Memory",
  "hostingDetail.runtime": "Runtime",
  "hostingDetail.addons": "Add-ons",
  "hostingDetail.created": "Created",
  "hostingDetail.nextInvoice": "Next invoice",
  "hostingDetail.lastChanged": "Last changed",
  "hostingDetail.ssl.provider": "Provider",
  "hostingDetail.ssl.status": "Status",
  "hostingDetail.ssl.active": "Active",
  "hostingDetail.ssl.inactive": "Not active",
  "hostingDetail.ssl.enable": "Enable SSL",
  "hostingDetail.ssl.selfsigned": "Temporary certificate",
  "hostingDetail.ssl.temporary": "Temporary — browsers show a warning",
  "hostingDetail.ssl.selfsignedHint": "Once your domain points to this server, we install a free Let's Encrypt certificate automatically.",
  "hostingDetail.copied": "Copied",
  "hostingDetail.copyFailed": "Copy failed",
  "hostingDetail.copy": "Copy",
  "hostingDetail.protocol": "Protocol",
  "hostingDetail.sftp.users": "SFTP users",
  "hostingDetail.sftp.addUser": "Add user",
  "hostingDetail.sftp.limit": "Your package has reached its maximum of {max} SFTP user(s).",
  "hostingDetail.sftp.empty": "No SFTP users yet.",
  "hostingDetail.sftp.noServer": "This hosting has no server yet; SFTP becomes available once it is set up.",
  "hostingDetail.sftp.createdOn": "Created {date}",
  "hostingDetail.sftp.newPassword": "New password",
  "hostingDetail.delete": "Delete",
  "hostingDetail.sftp.deleteUser": "Delete {name}",
  "hostingDetail.sftp.reset.title": "Generate a new password?",
  "hostingDetail.sftp.reset.body": "The current password of {name} will stop working.",
  "hostingDetail.sftp.reset.cta": "Generate",
  "hostingDetail.sftp.delete.title": "Delete SFTP user?",
  "hostingDetail.sftp.delete.body": "{name} will no longer be able to sign in.",
  "hostingDetail.sftp.deleted": "User deleted",
  "hostingDetail.sftp.add.title": "Add SFTP user",
  "hostingDetail.sftp.add.description": "The password is shown once after creation.",
  "hostingDetail.sftp.add.username": "Username (optional)",
  "hostingDetail.sftp.add.usernameHint": "Lowercase letters, digits, - and _. Leave empty for an automatic name.",
  "hostingDetail.sftp.add.invalid": "Invalid username.",
  "hostingDetail.secret.title": "Save this password",
  "hostingDetail.secret.description": "It is shown only once.",
  "hostingDetail.secret.done": "I've saved it",
  "hostingDetail.user": "User",
  "hostingDetail.db.adminer": "Open Adminer",
  "hostingDetail.db.none": "This plan has no database.",
  "hostingDetail.db.type": "Type",
  "hostingDetail.db.database": "Database",
  "hostingDetail.db.host": "Host (from your site)",
  "hostingDetail.db.password": "Password",
  "hostingDetail.hide": "Hide",
  "hostingDetail.show": "Show",
  "hostingDetail.runtime.current": "Current runtime",
  "hostingDetail.runtime.change": "Need a different version? Contact support and we will switch it for you.",
  "hostingDetail.cancel.pendingUntil": "Cancelled. The hosting runs until {date}.",
  "hostingDetail.cancel.pendingEndOfPeriod": "Cancelled. The hosting runs until the end of the period.",
  "hostingDetail.cancel.info": "Cancellation takes effect at the end of the current period. After that all files are deleted.",
  "hostingDetail.revoke.button": "Revoke cancellation",
  "hostingDetail.restart.title": "Restart hosting?",
  "hostingDetail.restart.started": "Restart started",
  "hostingDetail.cancel.title": "Cancel hosting?",
  "hostingDetail.cancel.body": "Are you sure you want to cancel {domain}?",
  "hostingDetail.cancel.submitted": "Cancellation submitted",
  "hostingDetail.revoke.title": "Revoke cancellation?",
  "hostingDetail.revoke.body": "The hosting will simply continue.",
  "hostingDetail.revoke.cta": "Revoke",
  "hostingDetail.revoke.done": "Cancellation revoked",
  "billingPage.noPaymentLink": "No payment link received. Please try again later.",
  "billingPage.mandate.loadFailed": "couldn't be loaded",
  "billingPage.mandate.none": "none set",
  "billingPage.openCount.one": "{n} invoice",
  "billingPage.openCount.other": "{n} invoices",
  "billingPage.allPaid": "all paid",
  "billingPage.inclVat": "incl. VAT",
  "billingPage.next.approx": "approx. {amount}",
  "billingPage.next.none": "no running subscriptions",
  "billingPage.sepa.enabled": "SEPA direct debit enabled",
  "billingPage.sepa.body": "Invoices are automatically charged on the due date.",
  "billingPage.revoke.cta": "Revoke mandate",
  "billingPage.noInvoices": "No invoices.",
  "billingPage.renews": "renews {date}",
  "billingPage.noSubscriptions": "No subscriptions.",
  "billingPage.add": "Add",
  "billingPage.method.loadFailed": "Your payment method couldn't be retrieved.",
  "billingPage.retry": "Try again",
  "billingPage.method.none": "No payment method set.",
  "billingPage.mandateStatus.valid": "active",
  "billingPage.mandateStatus.pending": "pending",
  "billingPage.mandateStatus.invalid": "invalid",
  "billingPage.mandateStatus.revoked": "revoked",
  "billingPage.revoke.done": "Mandate revoked",
  "billingPage.revoke.title": "Revoke SEPA mandate?",
  "billingPage.revoke.body": "Invoices will no longer be collected automatically. You'll pay them yourself from the invoice page.",
  "billingPage.working": "Working…",
  "billingPage.revoke.confirm": "Revoke",
  "billingDetail.notFound": "Invoice not found",
  "billingDetail.loadFailed": "Couldn't load invoice",
  "billingDetail.notFound.body": "This invoice doesn't exist or doesn't belong to your account.",
  "billingDetail.downloadFailed": "Download failed",
  "billingDetail.title": "Invoice {number}",
  "billingDetail.due": "Due {date}",
  "billingDetail.print": "Print",
  "billingDetail.payNow": "Pay now",
  "billingDetail.items": "Items",
  "billingDetail.hostingPlan": "Hosting {plan}",
  "billingDetail.hostingId": "Hosting #{id}",
  "billingDetail.services": "Services",
  "billingDetail.invoiceDate": "Invoice date",
  "billingDetail.vat": "VAT",
  "billingDetail.vatPct": "VAT ({pct}%)",
  "billingDetail.pdfNote": "The full breakdown is in the PDF.",
  "billingDetail.billedTo": "Billed to",
  "billingDetail.addressNote": "The full billing address is on the PDF. Something wrong? Get in touch with us.",
  "billingDetail.history": "History",
  "billingDetail.hist.created": "Invoice created",
  "billingDetail.hist.overdue": "Past due date",
  "billingDetail.hist.cancelled": "Invoice cancelled",
  "billingDetail.hist.paid": "Payment received",
  "billingDetail.pay.title": "Pay invoice",
  "billingDetail.pay.cta": "Continue to payment",
  "billingDetail.pay.choose": "Choose a payment method",
  "billingDetail.method.any": "Choose on the payment page",
  "billingDetail.method.any.sub": "All available payment methods",
  "billingDetail.method.ideal": "iDEAL",
  "billingDetail.method.ideal.sub": "Pay through your bank",
  "billingDetail.method.creditcard": "Credit card",
  "billingDetail.method.creditcard.sub": "Mastercard / Visa / Amex",
  "backupsPage.automatic": "Automatic",
  "backupsPage.kpi.lastSub": "last successful backup",
  "backupsPage.kpi.lastNone": "no backups yet",
  "backupsPage.kpi.successSub": "of finished backups succeeded",
  "backupsPage.kpi.storageSub": "total in kept backups",
  "backupsPage.days.one": "{n} day",
  "backupsPage.days.other": "{n} days",
  "backupsPage.kpi.retentionSub": "maximum",
  "backupsPage.noHostings": "No hostings found.",
  "backupsPage.every": "Every {h}h",
  "backupsPage.failed": "Failed",
  "backupsPage.noBackup": "No backup yet",
  "backupsPage.off": "Off",
  "backupsDetail.notFound": "Hosting not found",
  "backupsDetail.autoOff": "Automatic backups off",
  "backupsDetail.lastFailed": "Last backup failed",
  "backupsDetail.snapshots.one": "{n} snapshot",
  "backupsDetail.snapshots.other": "{n} snapshots",
  "backupsDetail.last": "last {time}",
  "backupsDetail.onlyActive": "Only for active hostings",
  "backupsDetail.running": "Backup running…",
  "backupsDetail.tab.schedule": "Schedule",
  "backupsDetail.create.title": "Make a backup now?",
  "backupsDetail.create.body": "The backup runs in the background; this can take a few minutes.",
  "backupsDetail.create.cta": "Start backup",
  "backupsDetail.create.done": "Backup started",
  "backupsDetail.restore.title": "Restore backup?",
  "backupsDetail.restore.body": "The current files and database of {domain} will be replaced by the backup from {date}. This cannot be undone.",
  "backupsDetail.restore.cta": "Restore",
  "backupsDetail.restore.done": "Restore started",
  "backupsDetail.pickSnapshot": "Pick a completed snapshot to restore.",
  "backupsDetail.empty.title": "No backups yet",
  "backupsDetail.empty.body": "The first automatic backup appears here once it has been made.",
  "backupsDetail.col.time": "Time",
  "backupsDetail.col.keptUntil": "Kept until",
  "backupsDetail.type.full": "Automatic",
  "backupsDetail.type.incremental": "Incremental",
  "backupsDetail.type.manual": "Manual",
  "backupsDetail.status.pending": "Queued",
  "backupsDetail.status.running": "Running",
  "backupsDetail.status.completed": "Completed",
  "backupsDetail.status.failed": "Failed",
  "backupsDetail.saved": "Backup schedule saved",
  "backupsDetail.auto.title": "Automatic backups",
  "backupsDetail.auto.toggle": "Make backups automatically",
  "backupsDetail.frequency": "Frequency",
  "backupsDetail.everyHours": "Every {n} hours",
  "backupsDetail.keepFor": "Keep for",
  "backupsDetail.retention": "Retention",
  "backupsDetail.working": "Working…",
  "dashboard.activity.verb.create": "{resource} created",
  "dashboard.activity.verb.update": "{resource} updated",
  "dashboard.activity.verb.delete": "{resource} deleted",
  "dashboard.activity.verb.restore": "{resource} restored",
  "dashboard.activity.verb.suspend": "{resource} suspended",
  "dashboard.activity.verb.unsuspend": "{resource} reactivated",
  "dashboard.activity.verb.register": "{resource} registered",
  "dashboard.activity.verb.cancel": "{resource} cancelled",
  "dashboard.activity.verb.renew": "{resource} renewed",
  "dashboard.activity.verb.pay": "{resource} paid",
  "dashboard.activity.resource.hosting": "Hosting",
  "dashboard.activity.resource.backup": "Backup",
  "dashboard.activity.resource.domain": "Domain",
  "dashboard.activity.resource.dns": "DNS record",
  "dashboard.activity.resource.email": "Email",
  "dashboard.activity.resource.invoice": "Invoice",
  "dashboard.activity.resource.payment": "Payment",
  "dashboard.activity.resource.user": "Account",
  "dashboard.activity.resource.server": "Server",
  "dashboard.activity.resource.package": "Plan",
  "domainDetail.allDomains": "All domains",
  "domainDetail.expiresIn.one": " · in {n} day",
  "domainDetail.expiresIn.other": " · in {n} days",
  "domainDetail.autoRenewState.on": "Auto-renew: on",
  "domainDetail.autoRenewState.off": "Auto-renew: off",
  "domainDetail.status.active": "Active",
  "domainDetail.status.pending": "Pending",
  "domainDetail.status.transferring": "Transferring",
  "domainDetail.status.expired": "Expired",
  "domainDetail.status.suspended": "Suspended",
  "domainDetail.status.unknown": "Unknown",
  "domainDetail.registration": "Registration",
  "domainDetail.autoRenew": "Auto-renew",
  "domainDetail.on": "On",
  "domainDetail.off": "Off",
  "domainDetail.nameservers": "Nameservers",
  "domainDetail.linkedServices": "Linked services",
  "domainDetail.webHosting": "Web hosting",
  "domainDetail.emailService.one": "Email ({n} mailbox)",
  "domainDetail.emailService.other": "Email ({n} mailboxes)",
  "domainDetail.notLinked": "This domain is not linked to hosting or email yet.",
  "domainDetail.openService": "Open {name}",
  "domainDetail.dns.simpleTitle": "What do you want to do?",
  "domainDetail.dns.allRecords": "All DNS records",
  "domainDetail.dns.simpleSub": "Pick a common task and we will set the DNS records for you.",
  "domainDetail.dns.advancedSub": "Not sure? Use simple mode.",
  "domainDetail.dns.mode": "DNS mode",
  "domainDetail.dns.simple": "Simple",
  "domainDetail.dns.advanced": "Advanced",
  "domainDetail.task.website.desc": "Set A and CNAME records so visitors reach your website.",
  "domainDetail.task.mail.title": "My email runs through…",
  "domainDetail.task.mail.desc": "Configure MX records for your mail provider.",
  "domainDetail.task.verify.title": "Verify a service",
  "domainDetail.task.verify.desc": "Place a TXT record to prove ownership (Google, Meta, …).",
  "domainDetail.task.forward.title": "Forward to another URL",
  "domainDetail.task.forward.desc": "Redirect visitors of this domain to another address.",
  "domainDetail.records.one": "{n} record",
  "domainDetail.records.other": "{n} records",
  "domainDetail.addRecord": "Add record",
  "domainDetail.noRecords": "No DNS records yet",
  "domainDetail.noRecords.sub": "Add a record or use simple mode.",
  "domainDetail.col.type": "Type",
  "domainDetail.name": "Name",
  "domainDetail.edit": "Edit",
  "domainDetail.editRecord": "Edit {type} {name}",
  "domainDetail.err.value": "Enter a value.",
  "domainDetail.err.ipv4": "Not a valid IPv4 address.",
  "domainDetail.err.ipv6": "Not a valid IPv6 address.",
  "domainDetail.err.hostname": "Not a valid hostname.",
  "domainDetail.err.priority": "Enter a priority.",
  "domainDetail.recordAdded": "Record added",
  "domainDetail.recordSaved": "Record saved",
  "domainDetail.deleteRecord.title": "Delete record?",
  "domainDetail.delete": "Delete",
  "domainDetail.recordDeleted": "Record deleted",
  "domainDetail.addDnsRecord": "Add DNS record",
  "domainDetail.editDnsRecord": "Edit DNS record",
  "domainDetail.propagation": "Changes can take up to 1 hour to become globally visible.",
  "domainDetail.working": "Working…",
  "domainDetail.typeFixed": "The type cannot be changed.",
  "domainDetail.ttlSeconds": "TTL (seconds)",
  "domainDetail.name.hint": "Use @ for {domain}, or e.g. www or mail.",
  "domainDetail.err.name": "Enter a name.",
  "domainDetail.priority.hint": "Lower = more important.",
  "domainDetail.replaced.one": "{n} existing record is replaced.",
  "domainDetail.replaced.other": "{n} existing records are replaced.",
  "domainDetail.website.desc": "Pick where your website runs. We set the right DNS records.",
  "domainDetail.recordsApplied": "Records applied",
  "domainDetail.website.where": "Where does your website run?",
  "domainDetail.website.ip": "An IP address",
  "domainDetail.website.ip.sub": "Your host gives you an IPv4 address.",
  "domainDetail.website.host": "A hostname (e.g. mysite.netlify.app)",
  "domainDetail.website.host.sub": "For services like Netlify, Vercel or Shopify. Applies to www.",
  "domainDetail.ipAddress": "IP address",
  "domainDetail.hostname": "Hostname",
  "domainDetail.preview.set": "We will set these records:",
  "domainDetail.mail.ours": "Our mail service",
  "domainDetail.mail.ours.desc": "Mailboxes are managed here in the portal ({n} active).",
  "domainDetail.mail.google.desc": "Gmail for your domain. Requires a Workspace account.",
  "domainDetail.mail.ms.desc": "Outlook for your domain. Requires a Microsoft 365 account.",
  "domainDetail.mail.custom": "Other provider",
  "domainDetail.mail.custom.desc": "Enter your provider's mail server.",
  "domainDetail.mail.none": "No email",
  "domainDetail.mail.none.desc": "No email on this domain. Removes the MX records.",
  "domainDetail.mail.desc": "Pick your mail provider. We replace the MX records.",
  "domainDetail.mail.cta": "Replace MX records",
  "domainDetail.mail.applied": "MX records applied",
  "domainDetail.mail.provider": "Mail provider",
  "domainDetail.mail.server": "Mail server",
  "domainDetail.preview.mxRemoved": "All MX records will be removed.",
  "domainDetail.verify.desc": "Many services ask for a TXT record to prove this domain is yours.",
  "domainDetail.verify.cta": "Create TXT record",
  "domainDetail.verify.created": "TXT record created",
  "domainDetail.verify.code": "Verification code",
  "domainDetail.verify.code.hint": "Usually starts with e.g. google-site-verification=",
  "domainDetail.preview.create": "We will create this record:",
  "domainDetail.redirect.desc": "Visitors are redirected automatically to the address you enter.",
  "domainDetail.create": "Create",
  "domainDetail.redirect.created": "Forward created",
  "domainDetail.redirect.from": "From",
  "domainDetail.redirect.from.hint": "@ for {domain}, or a subdomain like shop.",
  "domainDetail.redirect.from.err": "Use @ or a valid subdomain.",
  "domainDetail.redirect.to": "To (full URL)",
  "domainDetail.redirect.to.err": "Enter a full URL starting with https://",
  "domainDetail.redirect.type": "Redirect type",
  "domainDetail.redirect.301": "301 — permanent",
  "domainDetail.redirect.302": "302 — temporary",
  "domainDetail.redirect.keepPath": "Keep the path (/page → target/page)",
  "domainDetail.routing.title": "Current mail routing",
  "domainDetail.routing.change": "Change provider",
  "domainDetail.routing.none": "No email configured",
  "domainDetail.routing.noMx": "There are no MX records for this domain.",
  "domainDetail.deliverability": "Deliverability",
  "domainDetail.spf.missing": "No SPF record found. Recipients may treat your mail as spam.",
  "domainDetail.dkim.missing": "No DKIM record found.",
  "domainDetail.dmarc.policy": "Policy: {policy}",
  "domainDetail.dmarc.missing": "No DMARC record found. Recommended: p=quarantine.",
  "domainDetail.forwards": "Forwards",
  "domainDetail.add": "Add",
  "domainDetail.forwards.empty": "No forwards",
  "domainDetail.forwards.empty.sub": "Forward (a subdomain of) this domain to another address.",
  "domainDetail.forward.temporary": "Temporary",
  "domainDetail.forward.permanent": "Permanent",
  "domainDetail.forward.frame": "Frame",
  "domainDetail.forward.delete": "Delete forward {from}",
  "domainDetail.forward.delete.title": "Delete forward?",
  "domainDetail.forward.deleted": "Forward deleted",
  "domainDetail.ns.saved": "Nameservers saved",
  "domainDetail.ns.desc": "The nameservers decide who manages this domain's DNS. Choose our nameservers (we manage the zone) or your own.",
  "domainDetail.ns.label": "Nameserver {n}",
  "domainDetail.ns.invalid": "One or more nameservers are not a valid hostname.",
  "domainDetail.dnssec.enabled": "DNSSEC enabled",
  "domainDetail.dnssec.disabled": "DNSSEC disabled",
  "domainDetail.dnssec.desc": "DNSSEC cryptographically signs DNS responses. Recommended for production domains.",
  "domainDetail.dnssec.changed": "Changed {date}",
  "topbar.search.goToPage": "Go to page",
  "topbar.search.action": "Action",
  "topbar.action.addDomain": "Add domain",
  "topbar.action.createMailbox": "Create mailbox",
  "topbar.action.addDnsRecord": "Add DNS record",
  "topbar.action.restoreBackup": "Restore backup",
  "topbar.action.newPlan": "New hosting plan",
  "topbar.action.openInvoices": "Open invoices",
  "topbar.menu.open": "Open menu",
  "topbar.menu.close": "Close menu",
  "topbar.menu.label": "Menu",
  "topbar.menu.main": "Main menu",
  "topbar.search.title": "Search (⌘K)",
  "topbar.search.label": "Search",
  "topbar.search.placeholder": "Search…",
  "topbar.search.pages": "Pages",
  "topbar.search.actions": "Actions",
  "topbar.search.inputLabel": "Search page or action",
  "topbar.search.inputPlaceholder": "Search page or action…",
  "topbar.search.noResults": "No results for \"{q}\"",
  "topbar.search.navigate": "navigate",
  "topbar.search.open": "open",
  "topbar.search.close": "close",
  "topbar.notif.title": "Notifications",
  "topbar.notif.labelUnread": "Notifications, {n} unread",
  "topbar.notif.unread": "{n} unread",
  "topbar.notif.allCaughtUp": "All caught up",
  "topbar.notif.markAllRead": "Mark all read",
  "topbar.notif.loadError": "Notifications could not be loaded.",
  "topbar.notif.empty": "No notifications",
  "topbar.theme.toggle": "Toggle theme",
  "topbar.user.menu": "Account menu",
  "topbar.user.idCopied": "Customer ID copied",
  "topbar.user.customer": "Customer",
  "topbar.user.copy": "Copy",
  "topbar.user.copyId": "Copy customer ID",
  "topbar.user.darkTheme": "Dark theme",
  "account.title": "My account",
  "account.working": "Working…",
  "account.close": "Close",
  "account.change": "Change",
  "account.enable": "Enable",
  "account.disable": "Disable",
  "account.continue": "Continue",
  "account.copied": "Copied",
  "account.password": "Password",
  "account.currentPassword": "Current password",
  "account.logout.menu": "Sign out",
  "account.logout.title": "Sign out?",
  "account.logout.body": "You'll be signed out on this device. Connected mail clients and SSH sessions stay active.",
  "account.logout.cta": "Yes, sign out",
  "account.logout.done": "You have been signed out",
  "account.profile.saved": "Profile saved",
  "account.profile.fullName": "Full name",
  "account.profile.email": "Email",
  "account.profile.currentPasswordHint": "Required to change your email address.",
  "account.security.title": "Security & 2FA",
  "account.security.description": "Manage your password and two-factor authentication.",
  "account.security.passwordSub": "Change the password you sign in with.",
  "account.security.mfa": "Two-factor authentication",
  "account.security.mfaActive": "Active — authenticator app",
  "account.security.mfaOff": "Not enabled",
  "account.password.min": "At least {n} characters.",
  "account.password.mismatch": "Passwords do not match.",
  "account.password.changed": "Password changed",
  "account.password.wrongCurrent": "Your current password is incorrect.",
  "account.password.changeTitle": "Change password",
  "account.password.new": "New password",
  "account.password.confirm": "Confirm new password",
  "account.mfa.enabledTitle": "2FA is enabled",
  "account.mfa.recoveryBody": "Store these recovery codes somewhere safe. Each code works once if you don't have your phone.",
  "account.mfa.saved": "I've saved them",
  "account.mfa.enableTitle": "Enable two-factor authentication",
  "account.mfa.setupBody": "Add this account to your authenticator app (e.g. 1Password, Google Authenticator) with the key below, then enter the 6-digit code.",
  "account.mfa.introBody": "Once enabled, signing in also asks for a code from your authenticator app.",
  "account.mfa.key": "Key",
  "account.mfa.openInApp": "Open in authenticator app",
  "account.mfa.copyKey": "Copy key",
  "account.mfa.codeFromApp": "Code from the app",
  "account.mfa.disabled": "2FA disabled",
  "account.mfa.disableTitle": "Disable two-factor authentication",
  "account.mfa.disableBody": "Confirm with a code from your authenticator app.",
  "account.mfa.code": "Code",
  "login.title": "Welcome back",
  "login.subtitle": "Sign in to manage your hosting, domains and email.",
  "login.mfaCode": "Code from your authenticator app",
  "login.back": "Back",
  "login.submit": "Sign in",
  "login.noAccount": "No account yet? Contact us.",
  "dashboard.mailboxCount.one": "{n} mailbox",
  "dashboard.mailboxCount.other": "{n} mailboxes",
  "addDomain.description.check": "Check whether your domain is available and register it right away.",
  "addDomain.checking": "Checking…",
  "addDomain.prices": "Prices per year: {list}",
  "addDomain.term.years.one": "{n} year, then renewed yearly",
  "addDomain.term.years.other": "{n} years, then renewed yearly",
  "addDomain.cost.price": "{amount}, on your next invoice",
  "addDomain.renew": "Renewal",
  "addDomain.renew.price": "{amount} per year",
  "addDomain.status.registered": "{domain} is already registered. Try another name or extension.",
  "addDomain.status.reserved": "{domain} is reserved and cannot be registered.",
  "addDomain.status.premium": "{domain} is a premium domain. Contact us about the options.",
  "addDomain.status.invalid": "This is not a valid domain name.",
  "addDomain.status.unsupported_tld": "We don't offer this extension (yet).",
  "addDomain.status.unknown": "We couldn't tell whether {domain} is available. Please try again later.",
  "login.forgot": "Forgot password?",
  "public.toLogin": "Go to sign in",
  "public.missingToken": "This link is incomplete. Open the link from the email again or copy it in full.",
  "public.password.new": "New password",
  "public.password.repeat": "Repeat password",
  "public.password.hint": "At least {n} characters.",
  "public.password.tooShort": "Your password must be at least {n} characters long.",
  "public.password.mismatch": "The passwords don't match.",
  "verify.title": "Confirm email address",
  "verify.busy": "Confirming your email address…",
  "verify.ok": "Your email address is confirmed. You can now sign in.",
  "verify.invalid": "This confirmation link is invalid or has already been used. If your address is already confirmed, you can simply sign in.",
  "reset.request.title": "Forgot password",
  "reset.request.sub": "Enter your email address. We'll send you a link to set a new password.",
  "reset.request.submit": "Send reset link",
  "reset.request.sent": "If an account exists for {email}, a link will arrive in your inbox within a few minutes. The link is valid for 1 hour.",
  "reset.title": "Set a new password",
  "reset.sub": "Choose a new password for your account.",
  "reset.submit": "Save password",
  "reset.done": "Your password has been changed. Sign in with your new password.",
  "reset.invalid": "This reset link is invalid or has expired. Request a new one.",
  "reset.requestNew": "Request a new reset link",
  "invite.title": "Accept invitation",
  "invite.sub": "You've been invited to DMRS Console. Enter your name and choose a password to create your account.",
  "invite.name": "Full name",
  "invite.submit": "Create account",
  "invite.done": "Your account has been created. You can now sign in.",
  "invite.done.email": "Your account has been created. Sign in with {email} and your new password.",
  "invite.invalid": "This invitation is invalid or has already been used.",
  "invite.expired": "This invitation has expired. Ask the person who invited you for a new one.",
  "invite.registered": "An account already exists for this email address. Sign in or reset your password.",

  "addDomain.order.title": "Order {domain}",
  "addDomain.order.description": "You pay with Mollie. Once paid, we register the domain in the name of the holder below.",
  "addDomain.pricePerYear": "Price per year",
  "addDomain.period.one": "{n} year",
  "addDomain.period.other": "{n} years",
  "addDomain.period.price.one": "{n} year · {amount}",
  "addDomain.period.price.other": "{n} years · {amount}",
  "addDomain.vatNote": "Prices exclude 21% VAT.",
  "addDomain.pay": "Order and pay",
  "addDomain.redirecting": "Going to payment…",
  "addDomain.registered.title": "{domain} is already registered",
  "addDomain.registered.description": "Is this your domain? Link it to your account or transfer it to us.",
  "addDomain.choice.link": "I own it: link it",
  "addDomain.choice.link.sub": "Free. The registration stays with your current provider.",
  "addDomain.choice.transfer": "Transfer it to us",
  "addDomain.choice.transfer.sub": "{amount} excl. VAT. You need the transfer code from your current provider.",
  "addDomain.choice.transfer.unpriced": "You need the transfer code from your current provider.",
  "addDomain.link": "Link domain",
  "addDomain.linked": "{domain} has been linked",
  "addDomain.authCode": "Transfer code (EPP code)",
  "addDomain.authCode.hint": "Ask your current provider for this code.",
  "registrant.title": "Domain holder",
  "registrant.hint": "These details are recorded at the registry.",
  "registrant.name": "Name",
  "registrant.company": "Company (optional)",
  "registrant.address": "Address",
  "registrant.postalCode": "Postcode",
  "registrant.city": "City",
  "registrant.country": "Country",
  "registrant.phone": "Phone",
  "registrant.phone.hint": "For example +31 6 12345678",
  "registrant.email": "Email",
  "order.err.required": "Please fill in this field.",
  "order.err.invalid": "Please check this field.",
  "order.err.fields": "Please check the highlighted fields.",
  "order.err.notRegistered": "{domain} is not registered, so it cannot be transferred. Register it instead.",
  "order.err.alreadyManaged": "{domain} is already registered with us.",
  "order.err.orderExists": "There is already an open order for {domain}. You can find it on the domains page.",
  "order.err.paymentFailed": "The order was created, but the payment could not start. Please try again later from the domains page.",
  "order.err.priceUnavailable": "This extension has no price yet and cannot be ordered right now. Please contact us.",
  "orders.title": "Domain orders",
  "orders.checking": "Fetching your order status…",
  "orders.pay": "Pay",
  "orders.details": "Technical message",
  "orders.error.invalid_auth_code": "The transfer code (EPP) was rejected. Request a new code from your current provider and try again.",
  "orders.error.domain_unavailable": "This domain is not (or no longer) available for registration.",
  "orders.error.transfer_refused": "The current registrar or the registry refused the transfer. Check that the domain is unlocked.",
  "orders.error.contact_invalid": "The registrant details were not accepted. Check the address and phone number.",
  "orders.error.price_unavailable": "No price is available for this extension right now.",
  "orders.error.provider_error": "The registrar could not process the order. Our team has been notified and will contact you.",
  "orders.err.notPayable": "This order can no longer be paid.",
  "orders.action.register": "Registration",
  "orders.action.transfer": "Transfer",
  "orders.status.pending": "Awaiting payment",
  "orders.status.paid": "Paid",
  "orders.status.provisioning": "Processing",
  "orders.status.completed": "Completed",
  "orders.status.failed": "Failed",
  "orders.status.cancelled": "Cancelled",
  "orders.msg.pending": "We have not received your payment yet.",
  "orders.msg.provisioning.register": "Payment received. We are registering the domain now.",
  "orders.msg.provisioning.transfer": "Payment received. We are requesting the transfer now.",
  "orders.msg.completed.register": "{domain} is registered and appears in your list.",
  "orders.msg.completed.transfer": "The transfer of {domain} has been requested. This can take a few days.",
  "orders.msg.failed": "Processing {domain} failed. We have been notified and will contact you.",
  "domainDetail.ns.modeDefault": "Default",
  "domainDetail.ns.modeOwn": "Own nameservers",
  "domainDetail.ns.ownDesc": "At least two. With your own nameservers you manage the DNS at your own provider; the records here are then no longer used.",
  "domainDetail.ns.defaultExplain": "We manage the zone and set the nameservers at the registrar. Your records are ready before that happens.",
  "domainDetail.ns.registrarPicks": "The zone is at our registrar, which picks the nameservers itself.",
  "domainDetail.ns.source.own": "Set by you",
  "domainDetail.ns.source.package": "Part of your hosting plan",
  "domainDetail.ns.source.global": "Our default nameservers",
  "domainDetail.ns.source.bunny": "Our default nameservers",
  "domainDetail.ns.source.registrar": "Chosen by the registrar",
  "domainDetail.ns.state.ok": "Set at the registrar",
  "domainDetail.ns.state.pending": "Being set at the registrar",
  "domainDetail.ns.state.other": "Set these at your own registrar",
  "domainDetail.dnssec.enabledPending": "DNSSEC turned on; the key is being added at the registry",
  "domainDetail.dnssec.state.off": "DNSSEC is off.",
  "domainDetail.dnssec.state.on": "The zone is signed and its key is at the registry.",
  "domainDetail.dnssec.state.pending": "The zone is signed. The key is added at the registry as soon as possible.",
  "domainDetail.dnssec.state.copyDs": "The zone is signed. Add this DS record at your domain's registrar:",
  "domainDetail.dnssec.legacyZone": "This zone is always signed automatically.",
  "domainDetail.dnssec.ownNameservers": "With your own nameservers, DNSSEC is handled by your own DNS provider.",
  "addDomain.prestage": "Prepare only",
  "addDomain.prestage.hint": "Prepare: set up the DNS now and order the registration later. The domain then works right away.",
  "addDomain.prestaged": "{domain} is prepared. Set up the DNS and order the registration whenever you like.",
};
